export default function (date) {
    if (date) {
        if (parseInt(date.split("-")[0]) - 1911 < 99) {
            return '0' + `${parseInt(date.split("-")[0]) - 1911 + date.split(" ")[0].slice(4)}`
        }
        else {
            return parseInt(date.split("-")[0]) - 1911 + date.split(" ")[0].slice(4)
        }
    }
    else {
        return ''
    }

}
